module.exports = __webpack_public_path__ + "assets/img/NPC035.c916a14a.png";